import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchDoctorClinicRouters = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS,
) => {
  return axiosInstance.get(EndPoints.DOCTOR_CLINIC_ROUTER.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
    },
  });
};

export const fetchClinicDropdown = (payload) => {
  return axiosInstance.get(EndPoints.DOCTOR_CLINIC_ROUTER.DROPDOWN, payload);
};

export const createDoctorClinicRouter = (payload) => {
  return axiosInstance.post(EndPoints.DOCTOR_CLINIC_ROUTER.CREATE, payload);
};

export const updateDoctorClinicRouter = (payload) => {
  return axiosInstance.put(EndPoints.DOCTOR_CLINIC_ROUTER.UPDATE, payload);
};

export const deleteDoctorClinicRouter = (payload) => {
  const url = EndPoints.DOCTOR_CLINIC_ROUTER.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.DOCTOR_CLINIC_ROUTER.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};
